import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, concatMap } from 'rxjs/operators';
import { Observable, EMPTY, of } from 'rxjs';
import { ScenarioActions } from './scenario.actions';
import { ScenarioService } from '../../service/scenario.service';
import { httpScenarioResponse } from '../scenario/scenario.model';


@Injectable()
export class ScenarioEffects {

  // loadScenarios$ = createEffect(() => {
  //   return this.actions$.pipe(

  //     ofType(ScenarioActions.loadScenarios),
  //     concatMap(() =>
  //       /** An EMPTY observable only emits completion. Replace with your own observable API request */
  //       EMPTY.pipe(
  //         map(data => ScenarioActions.loadScenariosSuccess({ data })),
  //         catchError(error => of(ScenarioActions.loadScenariosFailure({ error }))))
  //     )
  //   );
  // });

  // getScenario$ = createEffect((
  //   scenarioService: ScenarioService = inject(ScenarioService),
  // ) => {
  //   return this.actions$.pipe(
  //     ofType(ScenarioActions.getScenario),
  //     concatMap(({ filter }) =>
  //       scenarioService.getScenario(filter).pipe(
  //         map((data: httpScenarioResponse) => ScenarioActions.getScenarioSuccess({ scenario: data })),
  //         catchError(error => of(ScenarioActions.getScenarioFailure())))
  //     )
  //   );
  // });


  constructor(private readonly actions$: Actions) { }
}
